<div class="vc-org-picker-wrapper">
    <vc-input
        class="vc-org-picker-wrapper-org-input"
        [label]="'COMMON_UI.ORGANIZATION' | transloco"
        [required]="false"
        [disabled]="true"
        [minimalStyles]="minimalStyles"
        [tooltip]="org?.name ?? ''"
        [style.height]="hideDescription ? '50px' : 'auto'"
        [value]="org?.name ?? ('CORE.SELECT_AN_ORGANIZATION' | transloco)"></vc-input>

    <vc-button
        iconName="edit_outline"
        [style.marginBottom]="hideDescription ? '0' : '22px'"
        [tooltip]="'COMMON_UI.EDIT' | transloco"
        mode="icon-tertiary"
        (trigger)="showOrgPicker()"></vc-button>

    @if (org?.name) {
        <vc-button
            ariaLabel="Clear input"
            iconName="close"
            [style.marginBottom]="hideDescription ? '0' : '22px'"
            mode="icon-tertiary"
            (trigger)="this.org = null; orgChange.emit(null)"></vc-button>
    }
</div>

<vc-org-picker
    [title]="'CORE.SELECT_AN_ORGANIZATION' | transloco"
    [primaryLabel]="'CORE.SELECT' | transloco"
    [loading]="loadingOrgs"
    [searchByFilter]="searchByFilter"
    [selectedOrg]="org"
    [(visible)]="orgDialogVisible"
    [orgModels]="orgOptions"
    [showTags]="true"
    (filterValueChange)="getOrgs($event)"
    (selectedOrgChange)="orgChange.emit($event)">
</vc-org-picker>
